import { handleActions } from 'redux-actions'
import { Immutable as ImmutableGenericsType } from 'seamless-immutable'
import get from 'lodash/get'

import { initialState, WizardState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils/redux'

const actionsNames = ['setUncompleted', 'setActualStep', 'setCompleted', 'setReferrerUrl']

interface Actions {
  setUncompleted: any
  setActualStep: any
  setCompleted: any
  setReferrerUrl: any
}

export const actions: Actions = prepareActions(actionsNames, 'wizard') as Actions

type State = ImmutableGenericsType<WizardState>

export default handleActions<State, Payload>(
  {
    [actions.setUncompleted]: (state, action): State => {
      const stepName: string = get(action, 'payload')
      return state.setIn(['steps', stepName, 'completed'], false)
    },
    [actions.setActualStep]: (state, action): State => {
      const actualStep: any = get(action, 'payload')
      return state.merge({ actualStep })
    },
    [actions.setCompleted]: (state, action): State => {
      const stepName: string = get(action, 'payload')
      return state.setIn(['steps', stepName, 'completed'], true)
    },
    [actions.setReferrerUrl]: (state, action): State => {
      const referrerUrl: string = get(action, 'payload')
      return state.set('referrerUrl', referrerUrl)
    },
  },
  initialState
)
